const init = () => {
  const imgFrame = document.querySelector('.js-productsImgFrame');
  const items = document.querySelectorAll('.js-productsItem');

  if (!imgFrame || items.length === 0) return;

  items.forEach((item, index) => {
    const num = index + 1;

    item.addEventListener('mouseenter', () => {
      removeAllImgNumClasses(imgFrame);
      imgFrame.classList.add(`is-ImgNum${num}`);
    });

    item.addEventListener('mouseleave', () => {
      imgFrame.classList.remove(`is-ImgNum${num}`);
    });
  });
}

const removeAllImgNumClasses = (element) => {
  const classes = [...element.classList];
  classes.forEach(cls => {
    if (cls.startsWith('is-ImgNum')) {
      element.classList.remove(cls);
    }
  });
}

export {
  init
}
